import { DateTime, DateTimeOptions } from "luxon";
import { logToDatadog } from "../services/datadog";

export const openingHourToDateTimeObject = (time: string, timezone?: string): DateTime => {
  const openingHourFormat = 'HH:mm:ss';
  const options: DateTimeOptions = {};
  if (timezone) {
    options.zone = timezone;
  }
  return DateTime.fromFormat(time, openingHourFormat, options)
}
export const isoStringToDateTimeObject = (isoDateString: string, convertToTimezone: string): DateTime => {
  return DateTime.fromISO(isoDateString, { zone: 'utc' }).setZone(convertToTimezone);
}

export const convertUtcDateStringForTimezone = (isoDateString: string, timezone: string, format?: Intl.DateTimeFormatOptions, locale: string = 'en-IE'): string => {
  const dt = DateTime.fromISO(isoDateString, { zone: 'utc' }).setZone(timezone);
  return format ? dt.setLocale(locale).toLocaleString(format) : dt.setLocale(locale).toLocaleString() || '';
}

export const convertUtcTimeStringForTimezone = (isoDateString: string, timezone: string): string => {
  const dt = DateTime.fromISO(isoDateString, { zone: 'utc' }).setZone(timezone);
  return dt.toLocaleString(DateTime.TIME_SIMPLE);
}

// Format is ddd, D MMM - eg: "Tue, 15 Aug"
export const shortDateStringOptions: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  day: 'numeric',
  month: 'short'
}

export const condensedDateTimeFormatString = 'yyyyLLddHHmm';
export const defaultTimezone = 'Europe/Dublin';
export const droneDeliveryDurationMinutes = 3;

export const createDateTimeFromFormat = (dateString: string, formatString: string): DateTime => {
  return DateTime.fromFormat(dateString, formatString);
};

export const createDateTimeFromIso = (dateString: string, timezone: string): DateTime => {
  return DateTime.fromISO(dateString, {zone: timezone});
};

export const convertDateTimeToFormattedString = (dateTimeObject: DateTime, formatString: string): string => {
  return dateTimeObject.toFormat(formatString);
};

export const removeSecondsFromIsoString = (isoString: string): string => {
  return isoString.slice(0,16);
}

export const isoToTimeString = (isoDateString: string): string => {
  const dateTime = DateTime.fromISO(isoDateString);
  return dateTime.toFormat('HH:mm');
};


//  ----- Legacy methods

export const tsToTimeDay = (ts: number | string, timezone: string): string => {
  // Check for missing, undefined, or empty input
  if (!ts || ts === "undefined" || ts === "") {
    return 'Invalid date';
  }
  
  try {
    const date = new Date(ts);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.warn('Invalid date value in tsToTimeDay:', ts);
      return 'Invalid date';
    }
    
    const newTimeAsDateTimeObject = isoStringToDateTimeObject(date.toISOString(), timezone);
    const dateString = convertUtcDateStringForTimezone(date.toISOString(), timezone, shortDateStringOptions);

    const newTime = `${newTimeAsDateTimeObject.toISOTime().slice(0,5)} ${dateString}`;
    return newTime;
  } catch (error) {
    logToDatadog('Error formatting date in tsToTimeDay', { error, ts, timezone }, 'error')
    return 'Invalid date';
  }
};

export const tsToLocalDateString = (ts: number | string, timezone: string): string => {
  // Check for missing, undefined, or empty input
  if (!ts || ts === "undefined" || ts === "") {
    return '';
  }
  
  try {
    const date = new Date(ts);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.warn('Invalid date value in tsToLocalDateString:', ts);
      return '';
    }
    
    const newTimeAsDateTimeObject = isoStringToDateTimeObject(date.toISOString(), timezone);
    const newTime = `${newTimeAsDateTimeObject.toISODate()}T${newTimeAsDateTimeObject.toISOTime().slice(0,5)}`;
    
    return newTime;
  } catch (error) {
    logToDatadog('Error formatting date in tsToLocalDateString', { error, ts, timezone }, 'error')
    return '';
  }
};